var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-error-alert"},[_c('div',{staticClass:"common-error-alert__inner",on:{"click":_vm.reload}},[_c('img',{attrs:{"src":require("@/assets/img/data_error_img.png"),"alt":"データが正常に取得できませんでした。電波の良いところで再度お試しください。"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }